import type { FC } from 'react';
import {
  WkFooter,
  FooterContainer,
  FooterNavigation,
  FooterItem,
  FooterNavigationLink,
  FooterCopyright,
} from '@wk/components-react16';

import './styles.css';

const Footer: FC = () => {
  return (
    <WkFooter mode="workflow">
      <FooterContainer mode="workflow">
        <FooterNavigation mode="workflow">
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href="https://pegasus.wkcloud.io"
            >
              Documentation{' '}
            </FooterNavigationLink>
          </FooterItem>
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href="https://wkengineering.atlassian.net.mcas.ms/browse/PCOM?McasTsid=20596&McasCtx=4"
            >
              Support{' '}
            </FooterNavigationLink>
          </FooterItem>
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href="https://pegasus.wkcloud.io/governance/orr/overview/"
            >
              Guides
            </FooterNavigationLink>
          </FooterItem>
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href="https://pegasus.wkcloud.io/governance/orr/orr-ado-extension/"
            >
              ADO Extension
            </FooterNavigationLink>
          </FooterItem>
        </FooterNavigation>
        <FooterCopyright
          mode="workflow"
          template="GBS Architecture & Engineering Services |  %year% %copy% Wolters Kluwer N.V. All rights reserved"
        ></FooterCopyright>
      </FooterContainer>
    </WkFooter>
  );
};

export default Footer;
